const API = `${window.location.origin}/api`;
export default API;
